<template>
    <div>
        <div class="modal fade" id="savePrintTemplateModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Save Print Template</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePrintTemplateModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label>Template Name</label>
                        <input class="form-control" type="text" v-model="templateName" id="">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closePrintTemplateModal()">Close</button>
                        <button type="button" class="btn btn-primary" @click="savePrintTemplate()">Save Template</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="printingNoteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel" v-if="!selectedNote">Add Printing Note</h5>
                        <h5 class="modal-title" id="exampleModalLabel" v-else>Update Printing Note</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePrintingNoteModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label>Printing Note</label>
                        <ckeditor-container id="comment" v-model="printingNote" :options="[]" @mention="addMention" mentionFrom="name"></ckeditor-container>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closePrintingNoteModal()">Close</button>
                        <button type="button" class="btn btn-primary" v-if="!selectedNote" @click="savePrintNote()">Save Note</button>
                        <button type="button" class="btn btn-primary" v-else @click="updatePrintNote()">Update Note</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="inline-block save-print-template w-full text-right mb-2">
            <div class="dropdown inline titleClass" title="Select Template" data-toggle="tooltip" data-placement="right" v-if="allTemplates.length > 0">
                <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ templateDropdownText }}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" @click="selectTemplate(template)" v-for="template in allTemplates">{{template.name}} <span><i @click="deleteTemplate(template)" class="fa fa-trash-o float-right p-1 titleClass hover:text-red" data-placement="right" aria-hidden="true" data-toggle="tooltip" title="Delete this template"></i></span></a>
                </div>
            </div>
            <button class="btn btn-sm btn-primary" @click="updatePrintTemplateModal()" v-if="selectedTemplate">Update Print Template</button>
            <button class="btn btn-sm btn-primary" @click="savePrintTemplateModal()">Save Print Template</button>
            <button class="btn btn-sm btn-primary" @click="printPage()">Print <i class="fa fa-print ml-1" aria-hidden="true"></i></button>
        </div>
        <div class="flex flex-wrap">
            <div :class="(printData.project_section == 'true')? 'w-full':'not-appear-in-print-overlay w-full'">
                <div class="row">
                    <div class="section-for-print m-0 p-0">
                        <div :class="(printData.project_section == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="project_section"
                                    @change="changeCheck('project_section')"
                                    v-model="printData.project_section"
                                    name="project_section"
                                    value="true"
                                    class="px-3 m-0 field-checkbox-for-print"
                                    unchecked-value="false"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-full"><h4 >PROJECT INFORMATION</h4></div>
                        </div>
                        <div :class="(printData.project.id == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="project_section_project_id"
                                    v-model="printData.project.id"
                                    name="project_section_project_id"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print project_section"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">ID</div>
                            <div class="w-1/2">{{project.custom_project_id ? project.custom_project_id : project.sequential_team_id}}</div>
                        </div>

                        <div :class="(printData.project.name == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="project_section_project_name"
                                    v-model="printData.project.name"
                                    name="project_section_project_name"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print project_section"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">Project Name</div>
                            <div class="w-1/2">{{project.name}}</div>
                        </div>

                        <div :class="(printData.project.address == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="project_section_project_address"
                                    v-model="printData.project.address"
                                    name="project_section_project_address"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">Address</div>
                            <div class="w-1/2">{{project.address}}</div>
                        </div>

                        <div :class="(printData.project.city == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="project_section_project_city"
                                    v-model="printData.project.city"
                                    name="project_section_project_city"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print project_section"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">City</div>
                            <div class="w-1/2">{{project.city}}</div>
                        </div>

                        <div :class="(printData.project.state == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="project_section_project_state"
                                    v-model="printData.project.state"
                                    name="project_section_project_state"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print project_section"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">State</div>
                            <div class="w-1/2">{{project.state}}</div>
                        </div>

                        <div :class="(printData.project.zip == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="project_section_project_zip"
                                    v-model="printData.project.zip"
                                    name="project_section_project_zip"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print project_section"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">Zip</div>
                            <div class="w-1/2">{{project.zip}}</div>
                        </div>

                        <div v-if="project.contact" class="w-full">
                            <div :class="(printData.project.contact_name == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                                <div class="flex-small">
                                    <b-form-checkbox
                                        id="project_section_project_contact_name"
                                        v-model="printData.project.contact_name"
                                        name="project_section_project_contact_name"
                                        value="true"
                                        unchecked-value="false"
                                        class="px-3 m-0 field-checkbox-for-print project_section"
                                    >
                                    </b-form-checkbox>
                                </div>
                                <div class="w-1/2">Contact</div>
                                <div class="w-1/2">{{project.contact.name}}</div>
                            </div>
                            <div :class="(printData.project.contact_phone == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                                <div class="flex-small">
                                    <b-form-checkbox
                                        id="project_section_project_contact_phone"
                                        v-model="printData.project.contact_phone"
                                        name="project_section_project_contact_phone"
                                        value="true"
                                        unchecked-value="false"
                                        class="px-3 m-0 field-checkbox-for-print project_section"
                                    >
                                    </b-form-checkbox>
                                </div>
                                <div class="w-1/2">Phone</div>
                                <div class="w-1/2">{{project.contact.phone}}</div>
                            </div>
                            <div :class="(printData.project.contact_fax == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                                <div class="flex-small">
                                    <b-form-checkbox
                                        id="project_section_project_contact_fax"
                                        v-model="printData.project.contact_fax"
                                        name="project_section_project_contact_fax"
                                        value="true"
                                        unchecked-value="false"
                                        class="px-3 m-0 field-checkbox-for-print project_section"
                                    >
                                    </b-form-checkbox>
                                </div>
                                <div class="w-1/2">Fax</div>
                                <div class="w-1/2">{{project.contact.fax}}</div>
                            </div>
                            <div :class="(printData.project.contact_cell == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                                <div class="flex-small">
                                    <b-form-checkbox
                                        id="project_section_project_contact_cell"
                                        v-model="printData.project.contact_cell"
                                        name="project_section_project_contact_cell"
                                        value="true"
                                        unchecked-value="false"
                                        class="px-3 m-0 field-checkbox-for-print project_section"
                                    >
                                    </b-form-checkbox>
                                </div>
                                <div class="w-1/2">Cell</div>
                                <div class="w-1/2">{{project.contact.cell}}</div>
                            </div>
                            <div :class="(printData.project.contact_email == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                                <div class="flex-small">
                                    <b-form-checkbox
                                        id="project_section_project_contact_email"
                                        v-model="printData.project.contact_email"
                                        name="project_section_project_contact_email"
                                        value="true"
                                        unchecked-value="false"
                                        class="px-3 m-0 field-checkbox-for-print project_section"
                                    >
                                    </b-form-checkbox>
                                </div>
                                <div class="w-1/2">Email</div>
                                <div class="w-1/2">{{project.contact.email}}</div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div :class="(printData.prequalifications_section == 'true')? 'w-full':'not-appear-in-print-overlay w-full'">
                <div class="row">
                    <div class="section-for-print m-0 p-0">
                            <div :class="(printData.prequalifications_section == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                                <div class="flex-small">
                                    <b-form-checkbox
                                        id="prequalifications_section"
                                        @change="changeCheck('prequalifications_section')"
                                        v-model="printData.prequalifications_section"
                                        name="prequalifications_section"
                                        value="true"
                                        class="px-3 m-0 field-checkbox-for-print"
                                        unchecked-value="false"
                                    >
                                    </b-form-checkbox>
                                </div>
                                <div class="w-full"><h4 >PREQUALIFICATIONS</h4></div>
                            </div>
                            <div :class="(printData.prequalifications.relate_and_connect == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                                <div class="flex-small">
                                    <b-form-checkbox
                                        id="project_section_project_relate_and_connect"
                                        v-model="printData.prequalifications.relate_and_connect"
                                        name="project_section_project_relate_and_connect"
                                        value="true"
                                        unchecked-value="false"
                                        class="px-3 m-0 field-checkbox-for-print prequalifications_section"
                                    >
                                    </b-form-checkbox>
                                </div>
                                <div class="w-1/2">Relate & Connect</div>
                                <div class="w-1/2">{{project.relate_and_connect}}</div>
                            </div>
                            <div :class="(printData.prequalifications.rules_of_engagement == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                                <div class="flex-small">
                                    <b-form-checkbox
                                        id="project_section_project_rules_of_engagement"
                                        v-model="printData.prequalifications.rules_of_engagement"
                                        name="project_section_project_rules_of_engagement"
                                        value="true"
                                        unchecked-value="false"
                                        class="px-3 m-0 field-checkbox-for-print prequalifications_section"
                                    >
                                    </b-form-checkbox>
                                </div>
                                <div class="w-1/2">Rules of Engagement</div>
                                <div class="w-1/2">{{project.rules_of_engagement}}</div>
                            </div>
                            <div :class="(printData.prequalifications.find_problems == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                                <div class="flex-small">
                                    <b-form-checkbox
                                        id="project_section_project_find_problems"
                                        v-model="printData.prequalifications.find_problems"
                                        name="project_section_project_find_problems"
                                        value="true"
                                        unchecked-value="false"
                                        class="px-3 m-0 field-checkbox-for-print prequalifications_section"
                                    >
                                    </b-form-checkbox>
                                </div>
                                <div class="w-1/2">Find Problems</div>
                                <div class="w-1/2">{{project.find_problems}}</div>
                            </div>
                            <div :class="(printData.prequalifications.money_steps == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                                <div class="flex-small">
                                    <b-form-checkbox
                                        id="project_section_project_money_steps"
                                        v-model="printData.prequalifications.money_steps"
                                        name="project_section_project_money_steps"
                                        value="true"
                                        unchecked-value="false"
                                        class="px-3 m-0 field-checkbox-for-print prequalifications_section"
                                    >
                                    </b-form-checkbox>
                                </div>
                                <div class="w-1/2">Money Step</div>
                                <div class="w-1/2">{{project.money_steps}}</div>
                            </div>
                            <div :class="(printData.prequalifications.decision_process == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                                <div class="flex-small">
                                    <b-form-checkbox
                                        id="project_section_project_decision_process"
                                        v-model="printData.prequalifications.decision_process"
                                        name="project_section_project_decision_process"
                                        value="true"
                                        unchecked-value="false"
                                        class="px-3 m-0 field-checkbox-for-print prequalifications_section"
                                    >
                                    </b-form-checkbox>
                                </div>
                                <div class="w-1/2">Decision Process</div>
                                <div class="w-1/2">{{project.decision_process}}</div>
                            </div>
                    </div>
                </div>

            </div>
            <div :class="(printData.record_details_section == 'true')? 'w-full':'not-appear-in-print-overlay w-full'">
                <div class="row">
                    <div :class="(printData.record_details_section == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                        <div class="flex-small">
                            <b-form-checkbox
                                id="record_details_section"
                                @change="changeCheck('record_details_section')"
                                v-model="printData.record_details_section"
                                name="record_details_section"
                                value="true"
                                class="px-3 m-0 field-checkbox-for-print"
                                unchecked-value="false"
                            >
                            </b-form-checkbox>
                        </div>
                        <div class="w-full"><h4 >RECORD DETAILS</h4></div>
                    </div>

                    <div class="section-for-print m-0 p-0">
                        <div :class="(printData.record_details.sales_contract_date == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="record_details_sales_contract_date"
                                    v-model="printData.record_details.sales_contract_date"
                                    name="record_details_sales_contract_date"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">Sales Contract Date</div>
                            <div class="w-1/2">{{project.sales_contract_date}}</div>
                        </div>
                        <div :class="(printData.record_details.base_bid == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="record_details_base_bid"
                                    v-model="printData.record_details.base_bid"
                                    name="record_details_base_bid"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">Base Bid</div>
                            <div class="w-1/2">{{project.base_bid}}</div>
                        </div>
                        <div :class="(printData.record_details.contract_amount == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="record_details_contract_amount"
                                    v-model="printData.record_details.contract_amount"
                                    name="record_details_contract_amount"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">Contract Amount</div>
                            <div class="w-1/2">{{project.contract_amount}}</div>
                        </div>
                        <div :class="(printData.record_details.login_date == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="record_details_login_date"
                                    v-model="printData.record_details.login_date"
                                    name="record_details_login_date"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">Login Date</div>
                            <div class="w-1/2">{{project.login_date}}</div>
                        </div>
                        <div :class="(printData.record_details.dead_date == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="record_details_dead_date"
                                    v-model="printData.record_details.dead_date"
                                    name="record_details_dead_date"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">Dead Date</div>
                            <div class="w-1/2">{{project.dead_date}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="(printData.misc_info_section == 'true')? 'w-full':'not-appear-in-print-overlay w-full'">
                <div class="row">
                    <div :class="(printData.misc_info_section == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                        <div class="flex-small">
                            <b-form-checkbox
                                id="misc_info_section"
                                @change="changeCheck('misc_info_section')"
                                v-model="printData.misc_info_section"
                                name="misc_info_section"
                                value="true"
                                class="px-3 m-0 field-checkbox-for-print"
                                unchecked-value="false"
                            >
                            </b-form-checkbox>
                        </div>
                        <div class="w-full"><h4 >MISCELLANEOUS INFORMATION</h4></div>
                    </div>
                    <div class="section-for-print m-0 p-0">


                        <div :class="(printData.misc_info.sales_status == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_sales_status"
                                    v-model="printData.misc_info.sales_status"
                                    name="misc_info_sales_status"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('sales-status')}}</div>
                            <div class="w-1/2">{{project.sales_status}}</div>
                        </div>
                        <div :class="(printData.misc_info.marketing_status == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_marketing_status"
                                    v-model="printData.misc_info.marketing_status"
                                    name="misc_info_marketing_status"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('marketing-status')}}</div>
                            <div class="w-1/2">{{project.marketing_status}}</div>
                        </div>
                        <div :class="(printData.misc_info.pre_bid == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_pre_bid"
                                    v-model="printData.misc_info.pre_bid"
                                    name="misc_info_pre_bid"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('pre-bid')}}</div>
                            <div class="w-1/2">{{project.pre_bid}}</div>
                        </div>
                        <div :class="(printData.misc_info.bid_date == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_bid_date"
                                    v-model="printData.misc_info.bid_date"
                                    name="misc_info_bid_date"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('bid-date')}}</div>
                            <div class="w-1/2">{{project.bid_date}}</div>
                        </div>
                        <div :class="(printData.misc_info.lead_from == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_lead_from"
                                    v-model="printData.misc_info.lead_from"
                                    name="misc_info_lead_from"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('lead-source')}}</div>
                            <div class="w-1/2">{{project.lead_from}}</div>
                        </div>
                        <div :class="(printData.misc_info.estimator == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_estimator"
                                    v-model="printData.misc_info.estimator"
                                    name="misc_info_estimator"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('estimator')}}</div>
                            <div class="w-1/2">{{project.estimator}}</div>
                        </div>
                        <div :class="(printData.misc_info.account_manager == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_account_manager"
                                    v-model="printData.misc_info.account_manager"
                                    name="misc_info_account_manager"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('account-mgr')}}</div>
                            <div class="w-1/2">{{project.account_manager}}</div>
                        </div>
                        <div :class="(printData.misc_info.take_off_person == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_take_off_person"
                                    v-model="printData.misc_info.take_off_person"
                                    name="misc_info_take_off_person"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('take-off-person')}}</div>
                            <div class="w-1/2">{{project.take_off_person}}</div>
                        </div>
                        <div :class="(printData.misc_info.products_and_Services == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_products_and_Services"
                                    v-model="printData.misc_info.products_and_Services"
                                    name="misc_info_products_and_Services"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('products-and-Services')}}</div>
                            <div class="w-1/2">{{project.products_and_Services}}</div>
                        </div>
                        <div :class="(printData.misc_info.client_profile == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_client_profile"
                                    v-model="printData.misc_info.client_profile"
                                    name="misc_info_client_profile"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('client-profile')}}</div>
                            <div class="w-1/2">{{project.client_profile}}</div>
                        </div>
                        <div :class="(printData.misc_info.contract_type == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_contract_type"
                                    v-model="printData.misc_info.contract_type"
                                    name="misc_info_contract_type"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('contract-type')}}</div>
                            <div class="w-1/2">{{project.contract_type}}</div>
                        </div>
                        <div :class="(printData.misc_info.office == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    id="misc_info_office"
                                    v-model="printData.misc_info.office"
                                    name="misc_info_office"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div
                                class="w-1/2">{{getFieldLabel('office')}}</div>
                            <div class="w-1/2">{{project.office}}</div>
                        </div>

                        <div v-for="(cf,index) in printData.misc_info.customFields" :class="(cf.print == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'" >
                            <div class="flex-small">
                                <b-form-checkbox
                                    :id="'cf_'+index+'_'+cf.label_value"
                                    v-model="cf.print"
                                    :name="'cf_'+index+'_'+cf.label_value"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">{{cf.label_value}}</div>
                            <div class="w-1/2">{{cf.value}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="(printData.sales_behaviors_section == 'true')? 'w-full':'not-appear-in-print-overlay w-full'">
                <div class="row">
                    <div :class="(printData.sales_behaviors_section == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                        <div class="flex-small">
                            <b-form-checkbox
                                id="sales_behaviors_section"
                                @change="changeCheck('sales_behaviors_section')"
                                v-model="printData.sales_behaviors_section"
                                name="sales_behaviors_section"
                                value="true"
                                class="px-3 m-0 field-checkbox-for-print"
                                unchecked-value="false"
                            >
                            </b-form-checkbox>
                        </div>
                        <div class="w-full"><h4 >SALES ACTIVITIES</h4></div>
                    </div>

                    <div class="section-for-print m-0 p-0">
                        <div v-for="(sb, index) in printData.sales_behaviors" :class="(sb.print == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    :id="'sb_'+index"
                                    v-model="sb.print"
                                    :name="'sb_'+index"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">{{sb.name}}</div>
                            <div class="w-1/2">{{sb.date !== null ? formatDate(sb.date, 'm/d/Y'): ''}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="(printData.client_information_section == 'true')? 'w-full':'not-appear-in-print-overlay w-full'">
                <div class="row">
                    <div :class="(printData.client_information_section == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                        <div class="flex-small">
                            <b-form-checkbox
                                id="client_information_section"
                                @change="changeCheck('client_information_section')"
                                v-model="printData.client_information_section"
                                name="client_information_section"
                                value="true"
                                class="px-3 m-0 field-checkbox-for-print"
                                unchecked-value="false"
                            >
                            </b-form-checkbox>
                        </div>
                        <div class="w-full"><h4 >CLIENT INFORMATION</h4></div>
                    </div>
                    <div class="section-for-print m-0 p-0">
                        <div v-for="(client, index) in printData.client_information" :class="(client.print == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    :id="'client_'+index"
                                    v-model="client.print"
                                    :name="'client_'+index"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div style="width: 16%; overflow-wrap: break-word;">{{client.company}}</div>
                            <div style="width: 16%; overflow-wrap: break-word;">{{client.name}}</div>
                            <div style="width: 16%; overflow-wrap: break-word;">{{client.cell}}</div>
                            <div style="width: 16%; overflow-wrap: break-word;">{{client.email}}</div>
                            <div style="width: 16%; overflow-wrap: break-word;">{{client.next_followup}}</div>
                            <div style="width: 16%; overflow-wrap: break-word;">{{client.status}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="(printData.milestones_section == 'true')? 'w-full':'not-appear-in-print-overlay w-full'">
                <div class="row">
                    <div :class="(printData.milestones_section == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                        <div class="flex-small">
                            <b-form-checkbox
                                id="milestones_section"
                                @change="changeCheck('milestones_section')"
                                v-model="printData.milestones_section"
                                name="milestones_section"
                                value="true"
                                class="px-3 m-0 field-checkbox-for-print"
                                unchecked-value="false"
                            >
                            </b-form-checkbox>
                        </div>
                        <div class="w-full"><h4 >PROJECT MILESTONES</h4></div>
                    </div>

                    <div class="section-for-print m-0 p-0">
                        <div v-for="(item, index) in printData.milestones" :class="(item.print == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                            <div class="flex-small">
                                <b-form-checkbox
                                    :id="'pm_'+index"
                                    v-model="item.print"
                                    :name="'pm_'+index"
                                    value="true"
                                    unchecked-value="false"
                                    class="px-3 m-0 field-checkbox-for-print"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="w-1/2">{{item.type}}</div>
                            <div class="w-1/2">{{item.marked_date}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div :class="(printData.comments_section == 'true')? 'w-full':'not-appear-in-print-overlay w-full'">
            <div class="row">
                <div :class="(printData.comments_section == 'true')? 'flex justify-between text-sm mb-2 w-full border-b align-items-baseline':'flex justify-between text-sm mb-2 w-full border-b align-items-baseline field-overlay'">
                    <div class="flex-small">
                        <b-form-checkbox
                            id="comments_section"
                            @change="changeCheck('comments_section')"
                            v-model="printData.comments_section"
                            name="comments_section"
                            value="true"
                            class="px-3 m-0 field-checkbox-for-print"
                            unchecked-value="false"
                        >
                        </b-form-checkbox>
                    </div>
                    <div class="w-full"><h4 >PROJECT COMMENTS</h4></div>
                </div>

                <div class="section-for-print m-0 p-0">
                    <div class="flex-col text-grey-darkest border-b-1 py-3" v-if="comments" v-for="comment in comments">
                        <div class="flex justify-between text-sm mb-2">
                            <div class="flex">
                                <div class="mr-4">{{ comment['date'] }}</div>
                                <div><span>{{ comment['company_contact']}}</span>
                                    <span class="text-grey-darkest font-medium">
                            {{ comment['company_contact_name'] }}
                        </span>
                                </div>
                            </div>
                            <div><span>Created by: </span><span
                                class="text-grey-darkest font-medium">{{ comment['created_by'] }}</span>
                            </div>
                        </div>
                        <div class="flex justify-between">
                            <div class="leading-tight mr-32 text-grey-darkest">
                                <div v-if="comment['from']" v-html="comment['from']"></div> <br v-if="comment['from']"/>
                                <div v-if="comment['to']" v-html="comment['to']"></div> <br v-if="comment['to']"/>
                                <div v-if="comment['subject']" v-html="comment['subject']"></div> <br v-if="comment['subject']"/>
                                <div v-if="comment['email_date']" v-html="comment['email_date']"></div> <br v-if="comment['email_date']"/>
                                <div v-if="comment['message']" v-html="comment['message']"></div> <br v-if="comment['message']"/>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2" v-else>
                        <div class="px-3 py-2 text-grey-darkest text-sm">
                            Your project does not currently have any comments.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div :class="'w-full'" v-if="allNotesCurrent.length > 0">
            <div class="row">
                <div class="section-for-print m-0 p-0">
                    <h4 class="w-full my-2">PRINTING NOTES</h4>
                    <div class="flex-col text-grey-darkest border-b-1 py-3" v-if="allNotesCurrent.length > 0" v-for="noteData in allNotesCurrent">
                        <div class="flex justify-between text-sm mb-2">
                            <div class="flex">
                                <div class="mr-4">{{ formatNoteDate(noteData.created_at) }}</div>
                            </div>
                            <div><span>Created by: </span><span
                                class="text-grey-darkest font-medium">{{ noteData.user.name }}</span>
                                <br class="noteDeleteHide">
                                <span class="noteDeleteHide">
                                    <i @click="deleteNote(noteData)" class="fa fa-trash p-1 float-right text-xl titleClass cursor-pointer text-red" data-placement="right" aria-hidden="true" data-toggle="tooltip" title="Delete this print note"></i>
                                    <i @click="editNote(noteData)" class="fa fa-pencil p-1 float-right text-xl titleClass cursor-pointer text-primary mr-3" data-placement="right" aria-hidden="true" data-toggle="tooltip" title="Edit this print note"></i>
                                </span>
                            </div>
                        </div>
                        <div class="flex justify-between">
                            <div class="leading-tight mr-32 text-grey-darkest">
                                <div v-if="noteData.note" v-html="noteData.note"></div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2" v-else>
                        <div class="px-3 py-2 text-grey-darkest text-sm">
                            Your project does not currently have any notes.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button class="btn btn-primary addPrintingNoteButton" @click="addPrintingNoteModal()">Add Printing Note</button>
    </div>
</template>
<script>
import moment from "moment";
import CkeditorContainer from "../shared/ckeditor-container.vue";
export default {
    name: 'project-print',
    props: ['project', 'comments', 'fieldLabels', 'firstModule', 'printingData', 'allTemplates', 'selectedTemplate', 'allNotesData'],
    components: {CkeditorContainer},
    data() {
        return {
            printData: this.printingData,
            templateName: '',
            templateDropdownText: (this.selectedTemplate)? this.selectedTemplate.name: 'Select Print Template',
            printingNote:'',
            allNotes: this.allNotesData,
            allNotesCurrent: [],
            selectedNote: null,
        };
    },
    methods: {
        formatDate(dateValue, formatValue){
            return moment(dateValue).format(formatValue);
        },
        changeCheck(id){
            console.log(id,this.printData.project_section);
            if (id === 'project_section'){
                let checkboxStatus = (this.printData.project_section == 'true') ? 'false' : 'true';
                this.printData.project.id = checkboxStatus;
                this.printData.project.name = checkboxStatus;
                this.printData.project.address = checkboxStatus;
                this.printData.project.city = checkboxStatus;
                this.printData.project.state = checkboxStatus;
                this.printData.project.zip = checkboxStatus;
                this.printData.project.contact_name = checkboxStatus;
                this.printData.project.contact_phone = checkboxStatus;
                this.printData.project.contact_fax = checkboxStatus;
                this.printData.project.contact_cell = checkboxStatus;
                this.printData.project.contact_email = checkboxStatus;
            }

            if (id === 'prequalifications_section'){
                let checkboxStatus = (this.printData.prequalifications_section == 'true') ? 'false' : 'true';
                this.printData.prequalifications.relate_and_connect = checkboxStatus;
                this.printData.prequalifications.rules_of_engagement = checkboxStatus;
                this.printData.prequalifications.find_problems = checkboxStatus;
                this.printData.prequalifications.money_steps = checkboxStatus;
                this.printData.prequalifications.decision_process = checkboxStatus;
            }

            if (id === 'record_details_section'){
                let checkboxStatus = (this.printData.record_details_section == 'true') ? 'false' : 'true';
                this.printData.record_details.sales_contract_date = checkboxStatus;
                this.printData.record_details.base_bid = checkboxStatus;
                this.printData.record_details.contract_amount = checkboxStatus;
                this.printData.record_details.login_date = checkboxStatus;
                this.printData.record_details.dead_date = checkboxStatus;
            }

            if (id === 'misc_info_section'){
                let checkboxStatus = (this.printData.misc_info_section == 'true') ? 'false' : 'true';
                this.printData.misc_info.sales_status = checkboxStatus;
                this.printData.misc_info.marketing_status = checkboxStatus;
                this.printData.misc_info.pre_bid = checkboxStatus;
                this.printData.misc_info.bid_date = checkboxStatus;
                this.printData.misc_info.lead_from = checkboxStatus;
                this.printData.misc_info.estimator = checkboxStatus;
                this.printData.misc_info.account_manager = checkboxStatus;
                this.printData.misc_info.take_off_person = checkboxStatus;
                this.printData.misc_info.products_and_Services = checkboxStatus;
                this.printData.misc_info.client_profile = checkboxStatus;
                this.printData.misc_info.contract_type = checkboxStatus;
                this.printData.misc_info.office = checkboxStatus;
                this.printData.misc_info.customFields = this.printData.misc_info.customFields.map(client => ({
                    ...client,
                    print: checkboxStatus
                }));
            }

            if (id === 'sales_behaviors_section'){
                let checkboxStatus = (this.printData.sales_behaviors_section == 'true') ? 'false' : 'true';
                this.printData.sales_behaviors = this.printData.sales_behaviors.map(behavior => ({
                    ...behavior,
                    print: checkboxStatus
                }));
            }

            if (id === 'client_information_section'){
                let checkboxStatus = (this.printData.client_information_section == 'true') ? 'false' : 'true';
                this.printData.client_information = this.printData.client_information.map(client => ({
                    ...client,
                    print: checkboxStatus
                }));
            }

            if (id === 'milestones_section'){
                let checkboxStatus = (this.printData.milestones_section == 'true') ? 'false' : 'true';
                this.printData.milestones = this.printData.milestones.map(client => ({
                    ...client,
                    print: checkboxStatus
                }));
            }
        },
        getFieldLabel(slug) {
            if (
                Array.isArray(this.fieldLabels) &&
                this.fieldLabels.length > 0 &&
                this.fieldLabels.hasOwnProperty(slug)
            ) {
                return this.fieldLabels[slug];
            } else {
                return this.capitalizeAndReplace(slug);
            }
        },
        capitalizeAndReplace(slug) {
            return slug.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
        },
        printPage(){
            window.print();
        },
        savePrintTemplate(){
            if(this.templateName.trim() == '' || this.templateName == null){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please enter template name.'
                });
                this.templateName = '';
                return false;
            }
            this.$nextTick(() => {
                axios.post('/project/print-save-template', {
                    printData: this.printData,
                    projectId: this.project.id,
                    templateName: this.templateName
                }).then((response) => {
                    this.closePrintTemplateModal();
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                });
            });
        },
        savePrintTemplateModal(){
            this.templateName = '';
            $('#savePrintTemplateModal').modal('show');
        },
        closePrintTemplateModal(){
            $('#savePrintTemplateModal').modal('hide');
            this.templateName = '';
        },
        selectTemplate(template){
            this.$nextTick(() => {
                axios.post('/project/print-select-template', {
                    projectId: this.project.id,
                    selectedTemplate: template
                }).then((response) => {
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                });
            });
        },
        updatePrintTemplateModal(){
            this.$nextTick(() => {
                axios.post('/project/print-update-template', {
                    printData: this.printData,
                    selectedTemplate: this.selectedTemplate
                }).then((response) => {
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                });
            });
        },
        deleteTemplate(template){
            event.stopPropagation();
            this.$nextTick(() => {
                Swal.fire({
                    title: 'Delete Print Template',
                    text: "Do you want to delete "+template.name+" printing template",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#ff0000',
                    confirmButtonText: 'Delete!'
                }).then((result) => {
                    if (result.value) {
                        axios.post('/project/print-delete-template', {
                            selectedTemplate: template
                        }).then((response) => {
                            this.closePrintTemplateModal();
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                            setTimeout(() => {
                                window.location.reload();
                            }, 1500);
                        });
                    }else{
                        return false;
                    }
                });
            });
        },
        addPrintingNoteModal(){
            this.printingNote = '';
            $('#printingNoteModal').modal('show');
        },
        addMention(){

        },
        addNote(allNotes, currentNote) {
            let currentItemNote = this.findNoteByNote(allNotes, currentNote);
            this.allNotesCurrent.push(currentItemNote);
        },
        findNoteByNote(allNotes, currentNote) {
            return allNotes.find(note => note.note === currentNote);
        },
        findNoteById(allNotes, id) {
            return allNotes.find(note => note.id === id);
        },
        deleteNoteCurrent(id) {
            this.allNotesCurrent = this.allNotesCurrent.filter(note => note.id !== id);
        },
        editCurrentNote(item, newNote) {
            const index = this.allNotesCurrent.findIndex(n => n.id === item.id);
            if (index !== -1) {
                this.$set(this.allNotesCurrent, index, {
                    ...this.allNotesCurrent[index],
                    note: newNote,
                });
            }
        },
        savePrintNote(){
            if(this.printingNote.trim() == ''){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please add some text to note'
                });
                return false;
            }else{
                this.$nextTick(() => {
                    axios.post('/project/print-note-save', {
                        note: this.printingNote,
                        projectId: this.project.id
                    }).then((response) => {
                        this.allNotes = response.data.allNotes;
                        this.addNote(response.data.allNotes,this.printingNote);
                        this.closePrintingNoteModal();
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    });
                });
            }
        },
        closePrintingNoteModal(){
            $('#printingNoteModal').modal('hide');
            this.printingNote = '';
        },
        formatNoteDate(noteDate){
            const momentObject = moment(noteDate);
            return momentObject.format("M/D/YYYY");
        },
        deleteNote(noteData){
            this.$nextTick(() => {
                Swal.fire({
                    title: 'Delete Print Note',
                    text: "Do you want to delete print note",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#ff0000',
                    confirmButtonText: 'Delete!'
                }).then((result) => {
                    if (result.value) {
                        axios.post('/project/print-note-delete', {
                            noteDataId: noteData.id
                        }).then((response) => {
                            this.deleteNoteCurrent(noteData.id)
                            this.allNotes = response.data.allNotes;
                            this.closePrintingNoteModal();
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                        });
                    }else{
                        return false;
                    }
                });
            });
        },
        editNote(noteData){
            this.selectedNote = noteData;
            $('#printingNoteModal').modal('show');
            this.printingNote = noteData.note;

        },
        updatePrintNote(){
            if(this.printingNote.trim() == ''){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please add some text to note'
                });
                return false;
            }else{
                this.$nextTick(() => {
                    axios.post('/project/print-note-update', {
                        note: this.printingNote,
                        noteId: this.selectedNote.id,
                    }).then((response) => {
                        this.allNotes = response.data.allNotes;
                        let currentNote = this.findNoteById(response.data.allNotes,this.selectedNote.id)
                        this.editCurrentNote(currentNote,this.printingNote);
                        this.closePrintingNoteModal();
                        this.selectedNote = null;
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    });
                });
            }
        },
    },
    mounted() {
        $(document).ready(function() {
            $('.titleClass').tooltip();
        });
    },
    watch: {

    },
    created() {

    }
}
</script>
<style scoped>
.not-appear-in-print-overlay {
    position: relative;
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    background: rgb(4 4 4 / 15%);
    border-radius: 10px;
}


.field-overlay {
    background: rgb(4 4 4 / 15%);
    border-radius: 10px;
}

.section-for-print,
.field-for-print{
    width: 96%;
}

.checkbox-for-print{
    width: 4%;
}

.flex-item {
    flex-grow: 1;
}

.flex-small{
    flex-grow: 0;
}

.row{
    margin: 0 !important;
}

.addPrintingNoteButton {
    position: fixed;
    bottom: 5%;
    right: 2%;
}

@media print {
    .not-appear-in-print-overlay {
        display:none;
    }

    .checkbox-for-print,
    .field-checkbox-for-print,
    .flex-small,
    .field-overlay,
    .save-print-template,
    .addPrintingNoteButton,
    .noteDeleteHide {
        display: none;
    }

    .section-for-print,
    .field-for-print {
        width: 100%;
    }
}
</style>
